const audioSources = new Map();

let activeAudioSourceId = null;

const AUDIO_MANAGER_EVENT = "audio-source-change";

const emitChange = () => {
  if (typeof window === "undefined") return;

  window.dispatchEvent(
    new CustomEvent(AUDIO_MANAGER_EVENT, {
      detail: {
        activeAudioSourceId,
      },
    }),
  );
};

const syncAudioSources = () => {
  audioSources.forEach((video, id) => {
    if (!video) return;

    video.muted = id !== activeAudioSourceId;
  });
};

export const registerAudioSource = (id, video) => {
  if (!id || !video) return () => {};

  audioSources.set(id, video);
  syncAudioSources();

  return () => {
    audioSources.delete(id);

    if (activeAudioSourceId === id) {
      activeAudioSourceId = null;
      syncAudioSources();
      emitChange();
    }
  };
};

export const claimAudioSource = (id) => {
  if (!id) return;

  if (activeAudioSourceId === id) {
    syncAudioSources();
    return;
  }

  activeAudioSourceId = id;
  syncAudioSources();
  emitChange();
};

export const releaseAudioSource = (id) => {
  if (!id || activeAudioSourceId !== id) return;

  activeAudioSourceId = null;
  syncAudioSources();
  emitChange();
};

export const getActiveAudioSourceId = () => activeAudioSourceId;

export const subscribeToActiveAudioSource = (callback) => {
  if (typeof window === "undefined") return () => {};

  const handler = (event) => {
    callback(event.detail?.activeAudioSourceId ?? null);
  };

  window.addEventListener(AUDIO_MANAGER_EVENT, handler);

  return () => {
    window.removeEventListener(AUDIO_MANAGER_EVENT, handler);
  };
};
